<div>
  @if (!isEntitlementRequestable) {
    <mat-card appearance="outlined" class="page page-narrow">
      <mat-card-subtitle>
        {{ 'APP_INSUFFICIENT_PERMISSION.TITLE' | translate }}
      </mat-card-subtitle>
      <mat-card-subtitle>
        {{ 'APP_INSUFFICIENT_PERMISSION.SITE_ERROR' | translate }}
      </mat-card-subtitle>

      <a [href]="signinLink">
        <button
          mat-raised-button
          [style.visibility]="!!accountGroupId ? 'visible' : 'hidden'"
          class="footer"
          type="submit"
          color="accent"
        >
          {{ 'APP_INSUFFICIENT_PERMISSION.SIGN_IN' | translate }}
        </button>
      </a>
    </mat-card>
  }
</div>
